module.exports = __webpack_public_path__ + "static/media/Nova-Carriers-logo-web.60f7af6a.png";